<template>
    <div class="app-login">
        <div class="container mt-5">

            <div class="row justify-content-center ">
                <div class="col-12 col-md-5 col-xl-4 my-5">

                    <h1 class="display-4 text-center mb-3 mt-md-5">
                        <span class="text-uppercase">M&O Law Consult</span>
                    </h1>

                    <auth-login v-if="loginState"></auth-login>

                    <auth-passwordReset v-else></auth-passwordReset>

                </div>
            </div>
        
        </div>
    </div>
</template>

<script>
    import Login from './Login.vue'
    import PasswordReset from './PasswordReset.vue';
    import { mapMutations, mapState } from 'vuex'

    export default {
        components: { authLogin: Login, authPasswordReset: PasswordReset },
        name: 'Index',
        data() {
            return {

            }
        },
        metaInfo: {
            title: 'Login',
            bodyAttrs: {
                class: 'bg-white'
            }
        },
        methods: {
            
        },
        computed: {
            ...mapState(['loginState'])
        },
        created() {
        }   
    }
</script>



// WEBPACK FOOTER //
// src/views/auth/Index.vue